import React, { MouseEvent, useEffect, useState } from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { TextButton } from '../TextButton';

import s from './styles.css';

interface ICountdownProps {
  onResendPhone(event: React.MouseEvent<HTMLButtonElement>): void;
}

export function Countdown({ onResendPhone }: ICountdownProps) {
  const [count, setCount] = useState(10);

  useEffect(() => {
    if (count === 0) {
      return;
    }

    const timeout = setTimeout(() => setCount(p => p - 1), 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [count]);

  if (count === 0) {
    return (
      <div className={s['reset-code-button']}>
        <TextButton onClick={(e: MouseEvent<HTMLButtonElement>) => onResendPhone(e)}>Получить код ещё раз</TextButton>
      </div>
    );
  }

  return (
    <div className={s['repeat-code-message']}>
      <ArticleParagraph1>Получить код ещё раз через {count} сек</ArticleParagraph1>
    </div>
  );
}
